// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--WObe7","tagWrapper":"Hero--tagWrapper--16QnT","icon":"Hero--icon--3Nc2d","star":"Hero--star--24Abs"};